var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.5 97.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 2v21.6c-.2 13.9-11.2 25-24.7 25S16.2 37.5 16 23.6V2m0 93.3V73.6c.2-13.8 11.2-25 24.7-25s24.5 11.2 24.7 25v21.6M2 2h77.5M2 95.3h77.5",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })));
}
SvgHourglass.displayName = 'Hourglass';
export default SvgHourglass;